export default {
  appointmentContainer: {
    title: 'Let’s plan the repair',
    text: 'Our repairers are available on the following slots',
    text2: 'These fringes correspond to the expected arrival time of the professional',
    actions: {
      primary: 'Confirm time',
      secondaryHelpText: 'None of these slots are convenient for you?',
      secondary: 'I would like to be called back'
    },
    dates: {
      months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Error! It was not possible to retrieve the days available for appointment.',
        postAppointment: 'Error! The selected appointment could not be scheduled.',
        postContact: 'Error! The contact could not be requested.'
      }
    }
  }
}
